import dayjs, { Dayjs } from 'dayjs';
import { formatLongDate } from 'src/utils/dateFormatting';

// Assumes a product still in the feed is delivered at least every working day, so a week covers
// weekends and bank holidays: a connected asset the feed hasn't updated for that long has most
// likely stopped being sent.
const STALE_AFTER_DAYS = 7;

export const describeFeedStaleness = (
  feedUpdatedOn: string | null,
  today: Dayjs = dayjs(),
): string | null => {
  if (!feedUpdatedOn) {
    return null;
  }
  const updated = dayjs(feedUpdatedOn);
  if (today.startOf('day').diff(updated.startOf('day'), 'day') < STALE_AFTER_DAYS) {
    return null;
  }
  return `This asset hasn't been updated from the data feed since ${formatLongDate(updated.toDate())}. If it has been transferred, closed or renumbered, disconnect it and update it.`;
};
